import { createAsyncThunk } from "@reduxjs/toolkit";
import { bestPlayerRepository } from "api/bestPlayerRepository";
import { clubsPlayersRepository } from "api/playersRepository";
import { teamsRepository } from "api/teamsRepository";
import { validationSearchUserName } from "common/helpers/validators/validationSearchUserName";
import {
  BestPlayerEntity,
  BestPlayerFiltersType,
  BestPlayerResponce,
  SeasonsForMvp,
  VotingEntity,
  VotingMatch,
} from "common/interfaces/bestPlayer";
import { ThunkApiType } from "common/interfaces/common";
import { Player, PlayersFilters, PlayerType } from "common/interfaces/players";
import { Team } from "common/interfaces/teams";
import { StateType } from "store";

export const getBestPlayerList = createAsyncThunk<BestPlayerResponce, BestPlayerFiltersType, ThunkApiType>(
  "bestPlayer/byFilter",
  (filters, { rejectWithValue }) => {
    validationSearchUserName(filters.FullName);

    return bestPlayerRepository.fetchByFilter(filters).catch((error) => rejectWithValue({ error }));
  }
);

export const getBestPlayer = createAsyncThunk<BestPlayerEntity, BestPlayerEntity["Id"], ThunkApiType>(
  "bestPlayer/byId",
  (id, { rejectWithValue }) => bestPlayerRepository.fetchById(id).catch((error) => rejectWithValue({ error }))
);

export const saveVoting = createAsyncThunk<void, VotingEntity, ThunkApiType>(
  "bestPlayer/publish",
  (voting, { rejectWithValue }) => bestPlayerRepository.saveVoting(voting).catch((error) => rejectWithValue({ error }))
);

export const deleteBestPlayer = createAsyncThunk<void, BestPlayerEntity["Id"], ThunkApiType>(
  "bestPlayer/delete",
  (id, { rejectWithValue }) => bestPlayerRepository.remove(id).catch((error) => rejectWithValue({ error }))
);

export const getMainTeamPlayers = createAsyncThunk<Player[], string | undefined, ThunkApiType>(
  "bestPlayer/getMainTeamPlayers",
  async (teamId, { rejectWithValue }) => {
    try {
      if (!teamId) {
        const { Id } = (await teamsRepository.fetchByFilter({ SortOrder: 1, Section: "Site" })).teams[0] || {};
        teamId = Id;
        if (!teamId) {
          throw new Error("Team ID not found");
        }
      }

      return await clubsPlayersRepository.fetchMainTeamPlayers(teamId, "Published", PlayerType.own);
    } catch (error) {
      return rejectWithValue({ error });
    }
  }
);

export const getVotingMatches = createAsyncThunk<VotingMatch[], string, ThunkApiType>(
  "bestPlayer/getVotingMatches",
  (teamId, { rejectWithValue }) =>
    bestPlayerRepository.getVotingMatches(teamId).catch((error) => rejectWithValue({ error }))
);
export const getSeasonForMvp = createAsyncThunk<SeasonsForMvp[], undefined, ThunkApiType>(
  "bestPlayer/GetSeasonForMvp",
  (_, { rejectWithValue }) => bestPlayerRepository.getSeasonForMvp().catch((error) => rejectWithValue({ error }))
);
export const getVotingTeams = createAsyncThunk<Team[], undefined, ThunkApiType>(
  "bestPlayer/getVotingTeams",
  (_, { rejectWithValue }) => bestPlayerRepository.getVotingTeams().catch((error) => rejectWithValue({ error }))
);
